function calculateIframePrice() {
  console.log('loading');
  function numberWithCommas(x) {
    if (x || x === 0) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
  }

  var totalPriceBlock = $('#total-price');
  var summaryTotalPrice = $('#summary-total-price');
  var coinsurancesJs = $('.coinsurances-js');
  var addedInsuranceJs = $('.added-insurance-js');
  var actualSubjectId = $('#insurance-subject-id').val();
  var actualSubjectBlock = $('#' + actualSubjectId);
  var selectInsuranceSubject = $('.select-insurance-subject');
  let customSelect = $('.custom-select');
  const masterOrderId = $('#masterOrderId').data('id');
  const locale = $('#locale').val();
  let currencySymbol = 'Kč';

  if (locale === 'sk') {
    currencySymbol = '€';
  }

  $(document).ready(function () {
    calculateDisplayPrice();
  });

  if ($('#toggle-checkbox').length) {
    let toggle = $('#toggle-checkbox');
    toggle.on('click', function () {
      if (toggle.is(':checked')) {
        customSelect.each(function () {
          customSelectSend($(this));
        });
        $('.added-obligatory').removeClass('is-hidden');
        $('.obligatory-section').removeClass('is-hidden');
        $('.obligatory-alert').removeClass('is-hidden');
      } else {
        let customSelect = $('.custom-select');
        var orderId = customSelect.data('order-id');
        $('.summary-obligatory').remove();
        $('.added-obligatory').addClass('is-hidden');
        $('.obligatory-section').addClass('is-hidden');
        $('.obligatory-alert').addClass('is-hidden');
        $.ajax({
          type: 'POST',
          url: '/update/iframe/obligatory-delete',
          data: { masterOrderId: masterOrderId },
          success: function () {
            //TODO nějaká notifikace?
          },
        });

        calculateDisplayPrice();
      }
    });
  }

  coinsurancesJs.on('click', function (event) {
    calculateDisplayPrice();
  });

  addedInsuranceJs.on('click', function (event) {
    calculateDisplayPrice();
  });

  selectInsuranceSubject.on('click', function (event) {
    $('#subject-coinsurances').addClass('is-hidden');
    $('#subject-added-insurances').addClass('is-hidden');
  });

  customSelect.each(function () {
    let customSelectThis = $(this);
    customSelectThis.on('click', function (event) {
      customSelectSend(customSelectThis);
    });
  });

  let couponCodeInput = $('.coupon-code-input');
  couponCodeInput.each(function () {
    let form = $(this).closest('form');
    let url = form.attr('action');
    $(this).on('change', function (event) {
      $.ajax({
        type: 'POST',
        url: url,
        data: form.serialize(), // serializes the form's elements.
        success: function (data) {
          var startDate = new Date(data.dateFrom);
          var endDate = new Date(data.dateTo);
          $('.date-start-text').html(
            startDate.getDate() +
              '.' +
              (startDate.getMonth() + 1) +
              '.' +
              startDate.getFullYear() +
              ' do ' +
              endDate.getDate() +
              '.' +
              (endDate.getMonth() + 1) +
              '.' +
              endDate.getFullYear()
          );
          $('.coupon-response').html(
            data.text +
              '<span class="discount-price-value">' +
              data.value +
              '</span>'
          );
          let discountType = $('#discount-type-hidden');
          discountType.attr('value', data.type);
          let hiddenPrice = document.getElementById('discount-type-hidden');
          hiddenPrice.dataset.percentage = data.valuePrice;
          calculateDisplayPrice();
          //TODO nastavit např. zelený box u inputu
        },
        error: function (data) {
          $('.coupon-response').html(data.responseJSON);
          //TODO nastavit např. zelený box u inputu
        },
      });
    });
  });

  function calculateDisplayPrice() {
    $('.summary-added-insurance-actual').remove();

    var selectedCoinsurance = $(
      "input[name='insurance_subject_order[coinsurance]']:checked"
    );
    var coinsurancePrice = selectedCoinsurance.data('price');
    var coinsuranceName = selectedCoinsurance.data('name');
    console.log(coinsuranceName);
    if (coinsurancePrice === undefined) {
      coinsurancePrice = actualSubjectBlock
        .find('.summary-subject-price-js')
        .data('price');
    }

    let securityAdded = false;
    let stepSecurityAdded = false;
    $('.added-insurance-checkbox:checked').each(function () {
      actualSubjectBlock
        .find('.' + $(this).data('type'))
        .find('.summary__item--group-headline')
        .removeClass('is-hidden');

      stepSecurityAdded = true;
      if ($(this).data('type') === 'added-security') {
        securityAdded = true;
      }

      actualSubjectBlock
        .find('.' + $(this).data('type'))
        .append(
          '<div class="summary__item summary__item--upsell summary-added-insurance-actual">' +
            $(this).data('name') +
            '<span class="js-data-price" data-price="' +
            $(this).data('price') +
            '">' +
            numberWithCommas($(this).data('price')) +
            ' ' +
            currencySymbol +
            '</span>' +
            '</div>'
        );
    });

    if (
      $('.added-insurance-checkbox:checked').length === 0 ||
      (stepSecurityAdded && !securityAdded)
    ) {
      if ($('.added-insurance-checkbox').length) {
        actualSubjectBlock
          .find('.added-security')
          .find('.summary__item--group-headline')
          .addClass('is-hidden');
      }
    }

    actualSubjectBlock
      .find('.summary-subject-price-js')
      .text(numberWithCommas(coinsurancePrice) + ' ' + currencySymbol)
      .data('price', coinsurancePrice);
    actualSubjectBlock.find('.summary-subject-name-js').text(coinsuranceName);

    var totalPrice = 0;
    $('.js-data-price').each(function () {
      totalPrice += $(this).data('price');
    });

    let discountType = $('#discount-type-hidden');
    if (discountType.attr('value') == 1) {
      var discount1 = parseInt(
        document.getElementById('discount-type-hidden').dataset.percentage
      );
      totalPrice -= discount1;
      $('.discount-price-value').each(function () {
        $(this).html('- ' + discount1 + ' ' + currencySymbol);
      });
    } else if (discountType.attr('value') == 2) {
      var percentage = parseInt(
        document.getElementById('discount-type-hidden').dataset.percentage
      );
      var discount = Math.round((totalPrice * percentage) / 100);
      totalPrice -= discount;
      $('.discount-price-value').each(function () {
        $(this).html('- ' + discount + ' ' + currencySymbol);
      });
    }

    totalPriceBlock.text(numberWithCommas(totalPrice) + ' ' + currencySymbol);
    summaryTotalPrice.text(numberWithCommas(totalPrice) + ' ' + currencySymbol);
    let summaryEndTotalPrice = $('#summary-end-total-price');
    if (summaryEndTotalPrice.length) {
      summaryEndTotalPrice.text(
        numberWithCommas(totalPrice) + ' ' + currencySymbol
      );
    }
    let endTotalPrice = $('#end-payment-total-price');
    if (endTotalPrice.length) {
      endTotalPrice.text(numberWithCommas(totalPrice) + ' ' + currencySymbol);
    }

    // update ceny do tmpTotalPrice v MasterOrder
    $.ajax({
      type: 'POST',
      url: '/change/iframe/tmpTotalPrice',
      data: { tmpTotalPrice: totalPrice, masterOrderId: masterOrderId }, // serializes the form's elements.
      success: function () {},
      error: function (data) {
        console.log(data);
        //TODO nastavit např. zelený box u inputu
      },
    });
  }

  function customSelectSend(customSelectFunction) {
    var blockId = customSelectFunction.data('block-id');
    var orderId = customSelectFunction.data('order-id');
    if (orderId) {
      var selectedItem = $('#select' + blockId).find(':selected');
      $('#item-price-' + blockId).html('+ ' + selectedItem.data('price'));
      $('#' + orderId)
        .find('.added-obligatory')
        .children('.summary-obligatory')
        .remove();
      customSelectFunction.closest('.summary-obligatory').remove();
      $('#' + orderId)
        .find('.added-obligatory')
        .find('.summary__item--group-headline')
        .addClass('is-hidden');
      if (selectedItem.data('price')) {
        $('#' + orderId)
          .find('.added-obligatory')
          .find('.summary__item--group-headline')
          .removeClass('is-hidden');
        $('#' + orderId)
          .find('.added-obligatory')
          .append(
            '' +
              '<div class="summary__item summary__item--upsell summary-added-insurance summary-obligatory">' +
              selectedItem.data('text') +
              '<span class="js-data-price" data-price="' +
              selectedItem.data('price') +
              '">' +
              numberWithCommas(selectedItem.data('price')) +
              ' ' +
              currencySymbol +
              '</span>' +
              '</div>'
          );
      }
      calculateDisplayPrice();
    }
  }
}
